<template>
  <div v-if="showGenerateTeamsLink" class="generate-teams-link">
    <button
      type="button"
      class="btn btn-outlined"
      :disabled="!canGenerate || generating"
      @click="generateTeamsLink"
    >
      Generate Teams link
    </button>
    <p v-if="showConnectHint" class="helper-text">
      Connect Microsoft from the
      <router-link to="/monitor/meetings">meetings inbox</router-link>
      to generate a Teams link.
    </p>
  </div>
</template>

<style scoped>
.helper-text {
  font-size: 0.9em;
  color: var(--kate-type-secondary);
  margin: 8px 0 0;
  font-style: italic;
}
</style>

<script>
import TimeMixin from '@mixins/time-mixins';
import useOAuthStore from '@stores/oauth-store';

export default {
  name: 'generate-teams-link-button',
  mixins: [TimeMixin],

  props: {
    learnerUserId: {
      type: Number,
      default: null,
    },
    isAdHoc: {
      type: Boolean,
      default: false,
    },
    // Standard programme meetings specify a module_meeting_id
    moduleMeetingId: {
      type: Number,
      default: null,
    },
    // Ad-hoc meetings specify a meeting_id
    meetingId: {
      type: Number,
      default: null,
    },
    startTime: {
      type: Date,
      default: null,
    },
    endTime: {
      type: Date,
      default: null,
    },
  },

  emits: ['generated'],

  data() {
    return {
      oauthStore: useOAuthStore(),
      generating: false,
    };
  },

  mounted() {
    if (this.showGenerateTeamsLink) {
      this.oauthStore.fetchConnectionStatus('microsoft');
    }
  },

  computed: {
    showGenerateTeamsLink() {
      return this.$featureFlags.isEnabled('ms-teams-integration');
    },
    entityId() {
      return this.isAdHoc ? this.meetingId : this.moduleMeetingId;
    },
    canGenerate() {
      return this.oauthStore.isProviderConnected('microsoft')
        && this.learnerUserId
        && this.entityId
        && this.startTime
        && this.endTime
        && this.startTime < this.endTime;
    },
    showConnectHint() {
      return this.oauthStore.isProviderStatusLoaded('microsoft')
        && !this.oauthStore.isProviderConnected('microsoft');
    },
    entityPath() {
      return this.isAdHoc ? 'ad-hoc-meetings' : 'meetings';
    },
  },

  methods: {
    generateTeamsLink() {
      this.generating = true;
      this.$Loading.minimal();
      this.$http.post(
        `/api/calendar/users/${this.learnerUserId}/${this.entityPath}/${this.entityId}/ms-teams-link`,
        {
          start_time: this.formatDate(this.startTime),
          end_time: this.formatDate(this.endTime),
        },
      ).then(response => {
        this.$emit('generated', {
          joinLink: response.data.join_link,
          teamsMeetingId: response.data.teams_meeting_id,
        });
        this.$ktoast.success('Teams link generated');
      }).catch(err => {
        this.$logger.autowarn('Error generating Teams link', undefined, err);
        this.$ktoast.showError(err);
      }).finally(() => {
        this.generating = false;
        this.$Loading.finish();
      });
    },
  },
};
</script>
